<template>
    <v-container>
        <v-row justify="center" class="mb-10">
            <v-col cols="12" md="8">
                <TopBar backPage="booking"/>
                <v-divider class=""></v-divider>
                <v-card class="mt-3">
                    <v-card-actions>
                        <h4>
                            تاریخچه رزروها
                        </h4>
                    </v-card-actions>
                        <v-divider
                        ></v-divider>
                    <v-card-text class="pa-1">
                        <v-card class="pa-4 border-b-sm border-solid mb-1" color="white" variant="flat"  v-for="(order,index) in $store.state.orders" :key="`order`+index">
                            <div class="d-flex justify-space-between align-center">
                                <span>
                                    زمان: {{ parseDate(order.order_day) }}
                                    ({{ order.order_time }})
                                </span> | 
                                <span>
                                    وضعیت: 
                                    <strong :class="orderStatusColor(order.status)">
                                        {{ orderStatusText(order.status) }}
                                    </strong>
                                </span>
                                <v-btn target="_blank" v-if="order.status == '1'" variant="flat" icon="mdi-chevron-left" :href="orderUrl(order)"></v-btn>
                            </div>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import TopBar from '@/components/top_bar.vue';

    export default {
        name: "OrdersPage",
        components: {
            TopBar,
        },
        data() {
            return {
                
            };
        },
        methods:{
            orderStatusText(status){
                status = Number.parseInt(status)
                let s = "نامشخص";
                switch (status) {
                    case 0:
                        s = "منتظر پرداخت"
                        break;
                    case 1:
                        s = "رزرو شده"
                        break;
                    case -100:
                        s = "لغو شده"
                        break;
                    case -1:
                        s = "خطا در تراکنش"
                        break;
                    default:
                        break;
                }
                return s;
            },
            orderStatusColor(status){
                status = Number.parseInt(status)
                let s = "text-red";
                switch (status) {
                    case 0:
                        s = "text-warning"
                        break;
                    case 1:
                        s = "text-success"
                        break;
                    case -100:
                        s = "text-red"
                        break;
                    case -1:
                        s = "text-lime"
                        break;
                    default:
                        break;
                }
                return s;
            },
            parseDate(d){
                const date = new Date(d);
                const formatter = new Intl.DateTimeFormat("fa-IR", {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                // hour: "2-digit",
                // minute: "2-digit",
                // second: "2-digit",
                hour12: false,
                });

                return formatter.format(date);
            },
            orderUrl(order){
                return this.$store.getters.getBaseUrl+`/booking/order/verify?t=${order.token}&id=${this.$store.state.info.form_id}&node_uid=${this.$store.getters.getNodeUid}`
            }
        },
        async created(){
            await this.$store.dispatch('GetOrders');
        }
    };
</script>

<style>
    .text-center {
        text-align: center;
    }
    

    .service-img {
        border-radius: 10px;
        transition: all .2s;
        width: 120px;
        height: 120px;
        object-fit: cover;
    }
    .cat-image {
        border-radius: 10px;
        transition: all .2s;
        width: 50px;
        height: 50px;
        object-fit: cover;
    }
    .v-slide-group__content{
        justify-content: center;
    }

.text-center input {
  text-align: center;
}
</style>